export default "__VITE_ASSET__DbQj_N2C__"